import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MenuTermsPageRoutingModule } from './menu-terms-routing.module';

import { MenuTermsPage } from './menu-terms.page';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, MenuTermsPageRoutingModule, TranslateModule.forChild(), PipesModule],
  declarations: [MenuTermsPage]
})
export class MenuTermsPageModule {}
